import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { verifyPinThunk } from "../features/auth/authThunk";
import OtpInputComponent from "../components/layout/OtpInputComponent";
import Button from "../components/ui/Button";

const VerifyPin: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { mobileNumber, deviceId, uuid, loading, error, consentHandle } = useAppSelector(
        (s) => s.auth
    );

    const [pin, setPin] = useState("");

    // Redirect if no mobile number
    useEffect(() => {
        if (!mobileNumber) {
            navigate("/login");
        }
    }, [mobileNumber, navigate]);



    // Removed the automatic effect that checks `verified` to stop it instantly jumping 
    // to dashboard when rendering after VerifyOtp (which also sets verified to true).
    const handleVerifySubmit = async () => {
        if (pin.length === 6) {
            const resultAction = await dispatch(verifyPinThunk({ mobileNumber, pin, deviceId: uuid || deviceId, consentHandle }));
            if (verifyPinThunk.fulfilled.match(resultAction)) {
                // If verification explicitly passes, move them directly to linking journey.
                navigate("/selectAccountType");
            }
        }
    };

    const maskedMobile = mobileNumber ? "XXXXXX" + mobileNumber.slice(-4) : "";

    return (
        <div className="flex flex-col min-h-screen bg-fin-bg">
            <div className="flex-1 flex flex-col p-6 items-center w-full max-w-sm mx-auto mt-10">
                <div className="h-14 w-14 bg-fin-primary/10 rounded-full flex items-center justify-center mb-6 border border-fin-primary/20">
                    <svg className="w-6 h-6 text-fin-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                </div>

                <div className="text-center mb-8 w-full">
                    <h2 className="text-[17px] font-semibold text-white">Enter your 6-digit PIN</h2>
                    <p className="text-sm text-fin-slate mt-2">Welcome back! Please enter your security PIN for +91 {maskedMobile}</p>
                </div>

                <div className="w-full flex justify-center mb-6">
                    <OtpInputComponent
                        value={pin}
                        onChange={(val) => setPin(val)}
                    />
                </div>

                {error && (
                    <div className="text-center w-full mb-6">
                        <p className="text-sm text-red-400 font-medium">{error}</p>
                    </div>
                )}

                <div className="text-center w-full flex flex-col gap-3 mt-2">
                    <button
                        onClick={() => navigate("/setPin?mode=reset")}
                        className="text-sm font-semibold text-fin-slate hover:text-white underline underline-offset-2"
                    >
                        Forgot PIN? Reset with OTP
                    </button>
                    <button
                        onClick={() => navigate("/setPin")}
                        className="text-sm font-semibold text-fin-primary hover:text-fin-400 underline underline-offset-2"
                    >
                        First time here? Set MPIN instead
                    </button>
                </div>
            </div>

            <div className="w-full bg-fin-surface border-t border-fin-border p-4 pb-6 mt-auto">
                <div className="max-w-sm mx-auto">
                    <Button
                        variant="primary"
                        fullWidth
                        disabled={pin.length < 6 || loading}
                        onClick={handleVerifySubmit}
                        className="py-3.5 text-[15px] font-bold"
                    >
                        {loading ? "Verifying..." : "Login"}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default VerifyPin;
